import { useSuspenseQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { TranslationOptions } from '@services/TranslatorService';
import TranslatorServiceInstance, { uefaVocabularyId } from '@services/TranslatorService';
import { language } from '@utilities/browser';

export type TranslateFn = (tag: string, options?: TranslationOptions) => string;

export const useTranslateFn = (vocabularyId = uefaVocabularyId) => {
  const { data: vocabulary } = useSuspenseQuery({
    queryKey: ['vocabulary', vocabularyId, language],
    queryFn: ({ signal }) => TranslatorServiceInstance.loadVocabulary(vocabularyId, language, signal),
  });

  const fn: TranslateFn = useCallback(
    (tag: string, options?: TranslationOptions) =>
      TranslatorServiceInstance.getWordFromVocabulary(vocabulary, tag, options),
    [vocabulary],
  );

  return fn;
};
